import React from "react";
import PolicyLayout from "./PolicyLayout";
import "../css/policy.scss";

const sections = [
  {
    id: "delivery-areas",
    title: "Where we deliver",
    body: [
      "The delivery destinations shown at checkout are the destinations currently supported by nartvmora. Destinations subject to applicable sanctions are excluded. A complete street address and a safe delivery location are required.",
      "Orders cannot be redirected after dispatch. If an address needs correcting, contact us as soon as possible; we can only update it before the parcel enters the carrier network.",
    ],
  },
  {
    id: "processing",
    title: "Processing and dispatch",
    body: [
      "In-stock orders are normally prepared within one to two business days. Weekends and public holidays are not processing days, and launches or promotional periods may add up to three business days.",
      "A dispatch email should include a tracking link once the carrier has scanned the parcel. Tracking can take several hours to begin updating.",
    ],
  },
  {
    id: "delivery-estimates",
    title: "Delivery estimates",
    body: [
      "The timeframes below are planning estimates measured from dispatch, not guarantees. Standard shipping costs US$9.99 per order.",
    ],
    table: [
      ["Hong Kong", "Usually 2–5 business days; US$9.99"],
      ["Asia-Pacific destinations", "Usually 5–10 business days; US$9.99"],
      ["Europe and North America", "Usually 7–15 business days; US$9.99"],
    ],
  },
  {
    id: "duties-delays",
    title: "Duties, taxes and delays",
    body: [
      "Destination taxes or brokerage fees may apply unless checkout clearly states that they have been collected. These charges are set by the destination authorities and are not included in the product price.",
      "Weather, customs reviews, service interruptions and regional demand can delay a parcel. If tracking has not changed for five business days after the estimated arrival date, contact us so the shipment can be investigated with the carrier.",
    ],
  },
  {
    id: "split-orders",
    title: "Pre-orders and split shipments",
    body: [
      "A pre-order product will display an expected dispatch window on its product page. If an order combines available and pre-order pieces, the items may be held and sent together unless separate delivery is offered at checkout.",
      "Occasionally an order may be split across parcels. Each parcel should receive its own tracking reference, and no additional delivery fee should be charged after checkout.",
    ],
  },
  {
    id: "delivery-help",
    title: "Missing or damaged parcels",
    body: [
      "Check the delivery address, safe places and nearby collection points before reporting a parcel missing. Visible transit damage should be photographed before the packaging is discarded and reported within seven days of delivery.",
    ],
    links: [
      { to: "/contact", label: "Contact customer care" },
      { to: "/returns", label: "Read the returns policy" },
    ],
  },
];

function Delivery() {
  return (
    <PolicyLayout
      title="Shipping & Delivery"
      intro="A clear guide to dispatch times, delivery estimates and what to do when a parcel needs attention."
      updated="Effective September 2026"
      sections={sections}
      action={{ to: "/contact", label: "Ask about a delivery" }}
    />
  );
}

export default Delivery;
